// ABOUTME: The "? Grown-up Tips" header pill -- toggles the Steersman coaching strip. Split out of
// ABOUTME: SteersmanStrip so it can sit in the header's right cluster instead of its own row (Issue #1940).

import { Chip } from '@mui/material';
import { CROSSING_FOCUS_RING, CROSSING_GOLD_INK, CROSSING_GOLD_V28, CROSSING_PAPER } from '../../../theme/crossingTokens';
import { usePhoneLayout } from '../runner/usePhoneLayout';

interface SteersmanToggleProps {
  showSteersman: boolean;
  onToggle: () => void;
}

export default function SteersmanToggle({ showSteersman, onToggle }: SteersmanToggleProps) {
  const phone = usePhoneLayout();

  return (
    <Chip
      label={phone ? '?' : '? Grown-up Tips'}
      aria-label="Grown-up Tips"
      variant="outlined"
      size="small"
      onClick={onToggle}
      role="button"
      aria-pressed={showSteersman}
      sx={{
        border: `1.5px dashed ${CROSSING_GOLD_V28}`,
        color: CROSSING_GOLD_INK,
        backgroundColor: CROSSING_PAPER,
        fontSize: '11px',
        fontWeight: 700,
        '&.Mui-focusVisible, &:focus-visible': { outline: `2px solid ${CROSSING_FOCUS_RING}`, outlineOffset: 2 },
      }}
    />
  );
}
